import React from "react";
import { RuleTypeEnum } from "../../Enum";

type RuleTypeSelectorProps = {
  selectedType: RuleTypeEnum;
  onSelect: (type: RuleTypeEnum) => void;
};

const RuleTypeSelector: React.FC<RuleTypeSelectorProps> = ({
  selectedType,
  onSelect,
}) => {
  return (
    <div className="flex justify-center gap-4 mb-6">
      {Object.values(RuleTypeEnum).map((type) => (
        <button
          key={type}
          type="button"
          onClick={() => onSelect(type)}
          className={`py-2 px-4 flex-1 text-sm font-medium rounded-md transition ${
            selectedType === type
              ? "bg-blue-600 text-white shadow-md"
              : "bg-gray-200 hover:bg-gray-300"
          }`}
        >
          {type} Rule
        </button>
      ))}
    </div>
  );
};

export default RuleTypeSelector;
